import type { TProductType } from 'constants/dictionaries';
import { REGION_LABEL_BY_PRODUCT_TYPE } from 'constants/labels';

export const getRegionLabelByProductType = (type: TProductType) => {
  return REGION_LABEL_BY_PRODUCT_TYPE[type] || REGION_LABEL_BY_PRODUCT_TYPE.Credit;
};
